module.exports = {"210122001":"蒲西街道","210122002":"蒲东街道","210122101":"于家房镇","210122102":"朱家房镇","210122103":"冷子堡镇","210122104":"刘二堡镇","210122105":"茨榆坨镇","210122106":"新民屯镇","210122107":"满都户镇","210122108":"杨士岗镇","210122109":"肖寨门镇","210122110":"长滩镇","210122111":"四方台镇","210122112":"城郊镇","210122113":"六间房镇","210122114":"养士堡镇","210122115":"潘家堡镇","210122117":"老大房镇","210122118":"大黑岗子镇","210122119":"牛心坨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210122.json
// module id = 510
// module chunks = 0